




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import associationCard from './associationCard.vue';
import * as sheetAPI from '@/apis/sheet';
import { calculationDynameicTables, handleValueFormula } from '../widget/valueConfig';
@Component({
	components: {
		associationCard,
	},
})
export default class App extends Vue {
	@Prop({ default: () => ({}) }) public association!: any;
	@Prop({ default: '' }) public recordId!: string;
	@Prop({ default: true }) public isAssociationSearch!: boolean;
	private tableData: any = [];
	private select: any[] = [];
	private input: string = '';
	private loading = false;
	private finished = false;
	private visiable: boolean = false;
	// 禁止加载
	private disabled: boolean = false;
	private page = { pageNumber: 0, pageSize: 10, total: 0 };
	// 添加关联记录
	public async open() {
		this.select = [];
		this.input = '';
		this.visiable = true;
		this.page = { pageNumber: 0, pageSize: 10, total: 0 };
		this.finished = true;
		this.tableData = [];
		this.search(true);
	}
	public close() {
		this.visiable = false;
	}
	public searchList() {
		this.page = { pageNumber: 0, pageSize: 10, total: 0 };
		this.finished = true;
		this.tableData = [];
		this.search(true);
	}
	public async search(isStart) {
		let { worksheetId, businessId } = this.association;
		const pageNum = this.page.pageNumber + 1;
		let res;
		if (this.isAssociationSearch) {
			res = await sheetAPI.getAssociationRecordList({
				worksheetId,
				recordId: this.recordId || undefined,
				titleFieldQueryStr: this.input,
				associationTableBusinessId: businessId,
				page: { pageNumber: pageNum, pageSize: this.page.pageSize },
			});
		} else {
			res = await sheetAPI.listDynamicTableRecord({
				title: this.input,
				dynamicTableBusinessId: businessId,
				page: { pageNumber: pageNum, pageSize: this.page.pageSize },
			});
		}

		this.loading = false;
		if (res.success) {
			let { records } = res.data;
			records = records || [];
			// let list = pageNum === 1 ? records : [].concat(this.tableData, records)
			// this.tableData = list || []
			if (isStart) {
				this.tableData = records;
			} else {
				this.tableData = this.tableData.concat(records);
			}
			this.page.total = res.data.page.total;
			this.finished = this.tableData.length >= this.page.total;
			this.page.pageNumber = pageNum;
		}
	}
	private selectItem(id: any, index: any) {
		// 单选
		if (this.association.associationRecordCount === 1) {
			this.select = [id];
		} else if (this.select.indexOf(id) > -1) {
			this.select = this.select.filter((item) => {
				return item !== id;
			});
		} else {
			console.log(0);
			this.select.push(id);
		}
	}
	// 计算公式数据
	private calculationFormula(val) {
		if (this.association.fieldType === 'dynamicTable') {
			const { tableFields } = this.association;
			tableFields.forEach((item) => {
				if (item.defaultType === 2 && item.defaultValue) {
					val[item.businessId] = calculationDynameicTables(
						{
							field: item,
						},
						(set, formula, resultFn) => {
							let params = {};
							let hasValue = Array.from(set).every((one: any) => {
								if (!val[one]) {
									return false;
								}
								params[one] = handleValueFormula(val[one], item);
								return true;
							});
							if (hasValue) {
								// 返回值处理
								return resultFn
									? resultFn(formula.evaluate(params), item)
									: formula.evaluate(params);
							}
						}
					);
				}
			});
		}
		return val;
	}
	private async load() {
		this.search(false);
	}
	private submit() {
		if (this.select.length) {
			this.$emit(
				'submit',
				this.tableData
					.filter((item) => {
						return this.select.includes(item.id);
					})
					.map(this.calculationFormula)
			);
			// this.$emit('selectData', this.select)
			this.visiable = false;
		}
	}
}
